import apiClient from '@/api/index'

export const shiftPlaningModule = {
    namespaced: true,

    state:() => ({
        isLoading: true,
        shiftRoles: null,
        sections: null,
        stations: null,
        shiftPlanings: null,
        defaultSection: null,
        nonUniqueErr: false,
    }),

    mutations: {
        setShiftRoles(state, data) {
            state.shiftRoles = data
        },

        setSections(state, data) {
            if(data.length !== 0) {
                state.sections = data
            } else {
                state.sections = null
            }
        },

        setStations(state, data) {
            state.stations = data
        },

        setShiftPlanings(state, data) {
            if(data.length !== 0) {
                state.shiftPlanings = data
                state.defaultSection = data[0].id
                for(let section in data) {
                    if(data[section].roles.length != 0) {
                        for(let i = 0; i < data[section].roles.length; i++) {
                            data[section].roles[i].time_from ? data[section].roles[i].time_from = data[section].roles[i].time_from.substring(0, 5) : null
                            data[section].roles[i].time_to ? data[section].roles[i].time_to = data[section].roles[i].time_to.substring(0, 5) : null
                        }
                    }
                }
            } else {
                state.shiftPlanings = null
                state.defaultSection = null
            }
        },

        throwNonUniqueErr(state, bool) {
            state.nonUniqueErr = bool
            console.log(bool)
        }
    },

    actions: {
        fetchSections({ commit }, shop) {
            apiClient.get(`/projects/${shop.project_code}/${shop.code}/sections`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setSections', response.data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        fetchStations({ commit }, shop) {
            apiClient.get(`/projects/${shop.project_code}/stations/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setStations', response.data)
            })
            .catch((error) => {
                console.log(error);
            });
        },

        fetchShiftPlanings({ state, commit }, shop) {
            console.log(shop)
            state.isLoading = true
            apiClient.get(`/projects/${shop.project_code}/${shop.code || shop.shop_code || shop.shop}/shift-plannings`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setShiftPlanings', response.data)
                state.isLoading = false
            })
            .catch((error) => {
                console.log(error);
            });
        },

        createNewSection({ commit, dispatch }, data) {
            apiClient
            .post(`/projects/tubatay/${data.shop}/shift-plannings/`,
            {
                shop: data.shop,
                revenue: data.revenue,
                efficiency: data.efficiency,
                copy_from: data.copy_from ? data.copy_from : null,
                pay_percent: data.pay_percent,
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', data)
            })
            .catch((error) => {
                console.log(error.response);
                commit('throwNonUniqueErr', true)
                // alert(error)
            });
        },

        deleteSection({ dispatch }, data) {
            console.log(data)
            apiClient.delete(`/projects/tubatay/${data.shop}/shift-plannings/${data.id}/`,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },
        editSection({ dispatch }, data) {
            apiClient
            .put(`/projects/tubatay/${data.shop_code}/shift-plannings/${data.id}/`,
            {
                id: data.id,
                shop: data.shop,
                revenue: data.revenue,
                pay_percent: data.pay_percent,
                efficiency: data.efficiency,
                copy_from: null
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                console.log(data)
                dispatch('fetchShiftPlanings', data)
            })
            .catch((error) => {
                console.log(error.response);
                commit('throwNonUniqueErr', true)
            });
        },

        addRow({ dispatch }, data) {
            apiClient
            .post(`/projects/tubatay/${data.shop}/shift-planning-roles/`,
            {
                description: data.description,
                section: data.section,
                hours: data.hours,
                shift_planning: data.shift_planning,
                station: data.station,
                time_from: data.time_from,
                time_to: data.time_to,
                pay_rate: data.pay_rate
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        editRow({ dispatch }, data) {

            apiClient
            .patch(`/projects/tubatay/${data.shop}/shift-planning-roles/${data.id}/`,
            {
                description: data.description,
                section: data.section,
                hours: data.hours,
                shift_planning: data.shift_planning,
                station: data.station,
                time_from: data.time_from,
                time_to: data.time_to,
                pay_rate: data.pay_rate
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        deleteRow({ dispatch }, data) {
            apiClient.delete(`/projects/tubatay/${data.shop}/shift-planning-roles/${data.id}/`,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        }
    }
}